export const initialValues = { email: '' };
